/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.monetization.rpc.PurchaseChirpService
 */

export const createPurchaseOrderRpc = {
  serviceName: 'com.hubspot.monetization.rpc.PurchaseChirpService',
  rpcName: 'createPurchaseOrder',
  auth: 'app',
  fingerprint: 'hVSSLmg9aqFnmoH1_3JNaBEOGDRJSanM'
};